// extracted by mini-css-extract-plugin
export default {"container":"Robot_container__W4Og8","panel":"Robot_panel__85msQ","wrapper":"Robot_wrapper__M32v-","info":"Robot_info__4drER","unit":"Robot_unit__-0naC"};